import store from "@/store";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AdminLayout from "@/layout/qMaster.vue";
import LoginPage from "@/pages/login.vue";
import NewsIndex from "@/pages/news/index.vue";
import ZaimuIndex from "@/pages/zaimu/index.vue";
import IRIndex from "@/pages/ir/index.vue";
import CatalogIndex from "@/pages/catalog/index.vue";

import ErrorPage from "@/pages/error.vue";
import NotFound from "@/pages/notFound.vue";

Vue.use(VueRouter);

const adminRouter: Array<RouteConfig> = [
  {
    path: "/admin",
    name: "admin",
    component: AdminLayout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "news",
        name: "admin.news",
        component: NewsIndex,
        meta: {
          pageTitle: "お知らせ管理 | 株式会社ヤガミ管理者専用サイト",
          title: "お知らせ管理 | 株式会社ヤガミ管理者専用サイト",
          subTitle: "お知らせ管理 | 株式会社ヤガミ管理者専用サイト",
          bodyClass: "mb__admin News",
          permission: [],
        },
      },
      {
        path: "zaimu",
        name: "admin.zaimu",
        component: ZaimuIndex,
        meta: {
          pageTitle: "財務情報管理 | 株式会社ヤガミ管理者専用サイト",
          title: "財務情報管理 | 株式会社ヤガミ管理者専用サイト",
          subTitle: "財務情報管理 | 株式会社ヤガミ管理者専用サイト",
          bodyClass: "mb__admin Zaimu",
          permission: [],
        },
      },
      {
        path: "ir",
        name: "admin.ir",
        component: IRIndex,
        meta: {
          pageTitle: "その他IR情報管理 | 株式会社ヤガミ管理者専用サイト",
          title: "その他IR情報管理 | 株式会社ヤガミ管理者専用サイト",
          subTitle: "その他IR情報管理 | 株式会社ヤガミ管理者専用サイト",
          bodyClass: "mb__admin IR",
          permission: [],
        },
      },
      {
        path: "catalog",
        name: "admin.catalog",
        component: CatalogIndex,
        meta: {
          pageTitle: "カタログ管理 | 株式会社ヤガミ管理者専用サイト",
          title: "カタログ管理 | 株式会社ヤガミ管理者専用サイト",
          subTitle: "カタログ管理 | 株式会社ヤガミ管理者専用サイト",
          bodyClass: "mb__admin Catarog",
          permission: [],
        },
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: {
      allowRole: [],
      pageTitle: "株式会社ヤガミ管理画面",
      title: "株式会社ヤガミ管理画面",
      subTitle: "株式会社ヤガミ管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "/logout",
    name: "logout",
    // component: LoginPage,
    meta: {
      allowRole: [],
      pageTitle: "株式会社ヤガミ管理画面",
      title: "株式会社ヤガミ管理画面",
      subTitle: "株式会社ヤガミ管理画面",
      bodyClass: "mb__admin mb__login",
      permission: [],
    },
  },
  {
    path: "*",
    redirect: "admin",
  },
  {
    path: "/not-found",
    name: "notFound",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: NotFound,
  },
  {
    path: "/error",
    name: "error",
    meta: {
      bodyClass: "ErrorBox",
    },
    component: ErrorPage,
  },
];

const routes = [...adminRouter];
const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log("index router");
  // store.dispatch("Router/setPreviousRouter", from);
  next();
  console.log("index router1");
  if (store.state.Auth.token) {
    next();
    return;
  }
  if (
    to.name != "login" &&
    to.name != "admin.login" &&
    to.name != "forgot.email" &&
    to.name != "forgot.resetPassword" &&
    !store.state.Auth.token
  ) {
    next({
      name: "login",
    });
  } else {
    if (
      (to.name === "login" || to.name == "admin.login") &&
      !store.state.Auth.token
    ) {
      next();
    } else if (to.name === "forgot.email" && !store.state.Auth.token) {
      next();
    } else if (
      to.matched[0] &&
      to.matched[0].name == "admin" &&
      store.state.Auth.token
    ) {
      next({
        name: "admin.user",
      });
    } else if (
      (to.name === "login" ||
        to.name === "forgot.email" ||
        to.name === "forgot.resetPassword") &&
      store.state.Auth.token
    ) {
      next({
        name: "admin.user",
      });
    } else if (
      to.matched[0] &&
      to.matched[0].meta.allowRole &&
      !to.matched[0].meta.allowRole.includes(store.state.Auth.role)
    ) {
      next({
        name: "forbiden",
      });
    } else {
      next();
    }
    console.log("index router2");
  }
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    document.body.setAttribute("class", to.meta.bodyClass || "");
    document.querySelector("#top")?.setAttribute("class", "mb__admin");
  });
});

export default router;
